import React from 'react';
import TelemedicinaPage from './TelemedicinaPage';
import Layout from '../../components/Layout';

async function action(context) {
  return {
    chunks: ['telemedicina'],
    title: 'E-Consulta',
    component: (
      <Layout hideLayout={context.query.hideLayout}>
        <TelemedicinaPage />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/telemedicina/index.js